export default __webpack_public_path__ + "static/mu-1151048a5521f7ac170b6ffbf4a95c34.svg";